import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import RecurringSubsListingsMobile from "./mobile-ui/RecurringSubsListingsMobile";
import { formatDateTimezon } from "../common-data/Converts";
import {
  CheckCircleIcon,
  CrossCircleIcon,
  EyeIcon,
  CallIcon,
  PersonIcon,
  EmailIcon,
  CalenderIcon,
  ClockIconV3,
  ExcludeIcon,
} from "../../images/icons/icons";
import CommonTable from "../common-components/common-tables/CommonTable";

const RecurringSubsListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  const {
    recurringSubscriptionLoading,
    recurringSubscriptionError,
    recurringSubscription,
  } = useSelector((state) => state.plans);

  const iniDatas = {
    pagination: [],
    allLeads: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  useEffect(() => {
    if (
      !recurringSubscriptionLoading &&
      !recurringSubscriptionError &&
      recurringSubscription?.status &&
      recurringSubscription?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allLeads: recurringSubscription.data,
        pagination:
          recurringSubscription?.pagination?.length > 0
            ? recurringSubscription.pagination
            : [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [
    recurringSubscriptionLoading,
    recurringSubscriptionError,
    recurringSubscription,
  ]);

  const tbColumns = [
    {
      dataField: "added_to_lead",
      text: "Action",
      formatter: (_, row) => {
        const isConvertedWithoutLMS = !row?.lead_id && row?.is_payment_done;
        const isLeadAdded = row?.added_to_lead || row?.is_payment_done;

        return (
          <>
            {isConvertedWithoutLMS ? (
              <span className="tb-data tb-badge tb-badge-success">
                Converted
              </span>
            ) : (
              <div className="pp-employee-payroll-actions">
                {isLeadAdded ? (
                  <button
                    key="view"
                    type="button"
                    className="pp-employee-payroll-action-button pp-outlined-border"
                    onClick={() =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        rowData: row,
                        modName: "view-lead-journey",
                      }))
                    }
                  >
                    <EyeIcon />
                    View Lead
                  </button>
                ) : (
                  <button
                    key="add-to-lmd"
                    type="button"
                    className="pp-employee-payroll-action-button pp-outlined-border"
                    onClick={() =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        rowData: row,
                        modName: "add-to-lead",
                      }))
                    }
                  >
                    <ExcludeIcon />
                    Add To LMS
                  </button>
                )}

                <button
                  key="click-to-call"
                  type="button"
                  className="pp-employee-payroll-action-button pp-outlined-border"
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      modName: "click-to-call",
                      rowData: row,
                    }))
                  }
                >
                  <CallIcon />
                  click to call
                </button>
              </div>
            )}
          </>
        );
      },
    },
    {
      dataField: "uid",
      text: "member info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div
              className="tb-flex"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "view_details",
                  rowData: row,
                  from: "recurring",
                }))
              }
            >
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data tb-link">{row?.name || "NA"}</span>
            </div>

            {row?.mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">{row.mobile || "NA"}</span>
              </div>
            )}

            {row?.email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>
                <span className="tb-data lowercase">{row.email || "NA"}</span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 45;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        const dateTime = row?.date_added ? row.date_added.split(" ") : null;
        const datePart = dateTime ? dateTime[0] : "-";
        const timePart = dateTime ? dateTime[1] + " " + dateTime[2] : "-";

        return (
          <span className="tb-data">
            {datePart} {timePart}
          </span>
        );
      },
    },
    {
      dataField: "is_payment_done",
      text: "Subscription Status",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.is_payment_done ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "added_on_lead",
      text: "Added to LMS",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalenderIcon />
              </span>
              <span className="tb-data">
                {row?.added_on_lead
                  ? formatDateTimezon(row.added_on_lead)
                  : "-"}
              </span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <ClockIconV3 />
              </span>
              <span className="tb-data">{row?.add_to_lms_time_dif || "-"}</span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "lead_from",
      text: "lead from",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.lead_from?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "keyword",
      text: "Landing Page Name",
      formatter: (_, row) => {
        return (
          <span className={`tb-data ${row?.keyword ? "lowercase" : ""}`}>
            {row?.keyword || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <div className="common-table-container tb-bordered hideMobile mt15">
        <CommonTable
          tableData={allDatas.allLeads}
          tablePagination={allDatas.pagination}
          tableColumns={tbColumns}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isLoading={recurringSubscriptionLoading}
        />
      </div>
      {/* <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table hideMobile mt-0">
        {recurringSubscriptionLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allLeads}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            isFirstColSticky={true}
          />
        )}
      </div> */}

      <div className="lead-logs-card-container only-mobile">
        <RecurringSubsListingsMobile
          tableData={allDatas.allLeads}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          setModValues={setModValues}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </>
  );
};

export default RecurringSubsListings;
